var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-nested-dropdown',{attrs:{"key_value":"id","nested_dropdown_list":_vm.nestedDropdown},scopedSlots:_vm._u([{key:"btn_slot",fn:function(){return [_c('p',[_vm._v("Dropdown")])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }